<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    .el-tabs__header {
        margin-top: -60px !important;
    }
    .el-tabs__nav-wrap {
        top: -1px !important;
    }
    .router-link-exact-active,
    .router-link-active {
        text-decoration: none;
    }
    .el-message-box {
        margin-top: -15% !important;
    }
    .el-dialog__header {
        background: #f2f5f8;
    }
    .el-dialog__body {
        border-top: 1px solid #dfdfdf;
        border-bottom: 1px solid rgb(231, 231, 231);
    }
    html,
    body {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0px;
        margin: 0px;
    }
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        widows: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue